const sortAlphabetical = (array) => {
  const newArray = array.slice();
  newArray.sort((a, b) => {
    let textA = a.name.toUpperCase();
    let textB = b.name.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
  return newArray;
};
const sortNumerical = (array, property) => {
  const newArray = array.slice();
  newArray.sort((a, b) => {
    let A = a[property] ? a[property] : 0;
    let B = b[property] ? b[property] : 0;
    return B - A;
  });
  return newArray;
};
export const sortingTypes = {
  Alphabetical: { method: sortAlphabetical },
  "Market Cap": {
    method: sortNumerical,
    property: "marketCap",
  },
};
